<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		num?: string;
		kicker: string;
		lede?: string;
		class?: string;
		title: Snippet;
	}

	const { num, kicker, lede, class: className = '', title }: Props = $props();

	// Drop the gutter column when `num` is omitted, and the right-hand lede column
	// when `lede` is omitted, so the title can fill the available row.
	const cols = $derived(
		num && lede
			? 'lg:grid-cols-[80px_minmax(0,2fr)_minmax(240px,1fr)]'
			: num
				? 'lg:grid-cols-[80px_minmax(0,1fr)]'
				: lede
					? 'lg:grid-cols-[minmax(0,2fr)_minmax(240px,1fr)]'
					: 'lg:grid-cols-1'
	);
</script>

<div class="mb-15 grid items-start gap-6 lg:gap-10 {cols} {className}">
	{#if num}
		<div class="text-soft-gray font-mono text-[13px] tracking-[0.16em]">{num}</div>
	{/if}
	<div>
		<div class="kicker mb-4">
			<span class="kicker-rule"></span>
			<span>{kicker}</span>
		</div>
		<h2
			class="text-primary m-0 font-semibold tracking-[-0.03em]"
			style="font-size: clamp(2rem, 4.4vw, 4.25rem); line-height: 1;"
		>
			{@render title()}
		</h2>
	</div>
	{#if lede}
		<p class="text-soft m-0 max-w-110 text-[17px] leading-[1.55] lg:self-center">{lede}</p>
	{/if}
</div>
